import { Box } from "@mui/material"
import Typography from "@mui/material/Typography"
import { FC, ReactElement } from "react"

import { ITEM_BORDER_MULTIPLIER } from "../../../themes/defaultThemeParams"

interface ICaptionImage {
    imageUrl: string
    caption: string
    color: string
    Icon: () => ReactElement
}

/** Displays and image with a caption. The caption has an icon */
const CaptionImage: FC<ICaptionImage> = ({
    imageUrl,
    caption,
    Icon,
    color,
}) => (
    <Box flexGrow={1}>
        <Box
            sx={{
                borderRadius: ITEM_BORDER_MULTIPLIER,
                position: "relative",
                height: "200px",
                width: "200px%",
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        />
        <Box display="flex" alignItems="center" color={color} mt={1}>
            <Icon />
            <Typography variant="body1" ml={1}>
                {caption}
            </Typography>
        </Box>
    </Box>
)

export default CaptionImage
